import { render, staticRenderFns } from "./TeachRoomList.vue?vue&type=template&id=6ddd8316&scoped=true&"
import script from "./TeachRoomList.vue?vue&type=script&lang=js&"
export * from "./TeachRoomList.vue?vue&type=script&lang=js&"
import style0 from "./TeachRoomList.vue?vue&type=style&index=0&id=6ddd8316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddd8316",
  null
  
)

export default component.exports